class BESSAppEvent extends BESSAppBase {

    constructor(name) {
        super();
        this.name = name;
    }
}

class BESSAppScreenLayoutChangedEvent extends  BESSAppEvent {

    static name = "BESSAppScreenLayoutChangedEvent";
    constructor() {
        super(BESSAppScreenLayoutChangedEvent.name);
    }

    static _firing = false;
    static layoutHasChanged(owner) {
        if(!this._firing) {
            this._firing = true;
            owner.fireEvent(new BESSAppScreenLayoutChangedEvent());
            setTimeout(function() {
                owner.fireEvent(new BESSAppScreenLayoutChangedEvent());
                this._firing = false;
            }.bind(this), 100);
        }
    }
}